export default from './Logo';


/** WEBPACK FOOTER **
 ** ./app/components/Logo/index.js
 **/